import { Button } from "@mui/material";
import styles from "./styles";

const OutlinedButton = ({ children, sx, ...props }) => {
  return (
    <Button
      variant="outlined"
      sx={{ ...styles.buttonSx, ...sx }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default OutlinedButton;
